import React, { useEffect, useState } from "react";
import { Table } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import agent from "../../../app/api/agent";
import { IPayrollTrace } from "../../../app/models/trackPayroll";
import LoadingComponent from "../../../app/layout/LoadingComponent";

interface IProps {
  id: string;
}

const ActionHistory: React.FC<IProps> = ({ id }) => {
  const [payrollTrace, setPayrollTrace] = useState<IPayrollTrace[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTrace = async () => {
      try {
        const data = await agent.Payroll.getPayrollTrace(id);
        setPayrollTrace(data);
      } catch (error) {
        console.error("Error loading trace:", error);
      } finally {
        setLoading(false);
      }
    };

    loadTrace();
  }, [id]);

  if (loading) {
    return <LoadingComponent content="Cargando historial..." />;
  }

  return (
    <div className="TableScroll">
      <Table striped basic unstackable compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Fecha de Acción</Table.HeaderCell>
            <Table.HeaderCell>Acción</Table.HeaderCell>
            <Table.HeaderCell>Observaciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {payrollTrace?.length > 0 ? (
            payrollTrace.map((trace) => (
              <Table.Row key={trace.trackId}>
                <Table.Cell singleLine>{trace.actionDate}</Table.Cell>
                <Table.Cell singleLine>{trace.action}</Table.Cell>
                {trace.observations.length > 0 ? (
                  trace.observations.map((ob) => (
                    <Table.Row key={`${trace.trackId}-${ob.code}`}>
                      <Table.Cell>{ob.message}</Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                )}
              </Table.Row>
            ))
          ) : (
            <Table.Row key="payrollTraceNull">
              <Table.Cell>No existen acciones</Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default observer(ActionHistory);
